import { render } from "./PerfilPaciente.vue?vue&type=template&id=9577c498&scoped=true"
import script from "./PerfilPaciente.vue?vue&type=script&lang=js"
export * from "./PerfilPaciente.vue?vue&type=script&lang=js"

import "./PerfilPaciente.vue?vue&type=style&index=0&id=9577c498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9577c498"]])

export default __exports__